import { CDN_URL } from '../../constants/http-constants';

/**
 * `websiteConfiguration.forms` is a schemaless JSON blob (not a dedicated entity), so the API
 * never computes an `imageUrl` for it the way it does for e.g. `CinemaCardDto.imageUrl`. Form
 * images are uploaded through the existing `/upload/cinema-card-image` endpoint instead, so the
 * ref is resolved into a URL the same way the backend's `AssetUrlFactory` does:
 * `{CDN_URL}/{namespace}/{ref}`.
 *
 * That endpoint publishes the file to the CDN inside the upload request (CIN-15048). Before, only
 * the CinemaCard handlers did, so form images never left the seven-day temp bucket and 404'd.
 */
export const FORM_IMAGE_UPLOAD_NAMESPACE = 'cinema-card-image';

export function getFormImageUrl(imageRef?: string | null): string | undefined {
    if (!imageRef) {
        return undefined;
    }
    return `${CDN_URL}/${FORM_IMAGE_UPLOAD_NAMESPACE}/${imageRef}`;
}
